import * as Yup from "yup";

export default Yup.object().shape({
  folder: Yup.string().required("Folder is required"),
});
